"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetch = void 0;
const utils_1 = require("../utils");
const CorrelationGroups_1 = require("../apis/CorrelationGroups");
const react_1 = require("react");
const react_2 = __importDefault(require("react"));
const emptyArray = [];
exports.useFetch = (params, endpoint) => {
    const { apiClient: client } = react_2.default.useContext(utils_1.AppContext);
    const apiClient = CorrelationGroups_1.useApiClientWithGroupCorrelationId(client);
    const fetchPromise = react_2.default.useCallback((_key, args) => {
        return args.endpoint
            ? new Promise((resolve, reject) => {
                apiClient
                    .request({
                    url: `${args.endpoint}`,
                    params: { ...args.params }
                })
                    .then((response) => {
                    resolve(response.data.d.results);
                })
                    .catch((e) => {
                    reject(e);
                });
            })
            : Promise.resolve(emptyArray);
    }, [apiClient]);
    const { data, isFetching, error } = utils_1.useQuery([`fetch`, { params, endpoint }], fetchPromise, {
        suspense: false
    });
    const result = react_1.useMemo(() => ({
        results: data,
        pending: isFetching,
        error
    }), [data, isFetching, error]);
    return result;
};
//# sourceMappingURL=useFetch.js.map